<template>
  <v-layout row>
    <v-flex xs12 sm9 offset-sm3 md6 offset-md6 xl4 offset-xl8>
      <v-card class="ma-3">
        <v-card-text>
          <v-layout wrap justify-space-around>
            <v-flex xs12 sm6>
              <v-autocomplete
                :items="vehiclesPlates"
                v-model="selectedVehicle"
                prepend-icon="directions_car"
                label="Vehículos"
                single-line
              ></v-autocomplete>
            </v-flex>
            <v-btn
              @click="$emit('today-report-range')"
              :dark="reportRange === 'today'"
              :outline="reportRange !== 'today'"
              color="primary"
              fab
              small
            >
            <v-icon>today</v-icon>
          </v-btn>
          <v-btn
            @click="$emit('custom-report-range')"
            :dark="reportRange === 'custom'"
            :outline="reportRange !== 'custom'"
            color="primary"
            fab
            small
          >
          <v-icon>build</v-icon>
        </v-btn>
        <v-menu offset-y bottom left>
          <v-btn icon slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="$emit('download-spreadsheet')">
              <v-list-tile-content>
                <v-list-tile-title>
                  Descargar Hoja de Cálculo
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="$emit('download-csv')">
              <v-list-tile-content>
                <v-list-tile-title>
                  Descargar CSV
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'actions',
  props: {
    reportRange: String,
    vehicles: Array
  },
  data: function () {
    return {
      selectedVehicle: null
    }
  },
  computed: {
    vehiclesPlates: function () {
      let vehiclesPlates = []
      for (let vehicle of this.vehicles) {
        vehiclesPlates.push(vehicle.plate)
      }
      return vehiclesPlates
    }
  },
  watch: {
    selectedVehicle: function (selectedVehicle) {
      const vehicle = _.find(this.vehicles, { plate: selectedVehicle })
      if (!vehicle) {
        return false
      }
      this.$emit('update-selected-vehicle', vehicle)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/Actions.vue